import React, { useRef, useState, useEffect } from "react";

export function FadeIn({ children, direction = "bottom" }) {
  const ref = useRef();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setVisible(true);
        observer.disconnect();
      }
    }, { threshold: 0.3 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`fade-in fade-in-${direction} ${visible ? "visible" : ""}`}
    >
      {children}
    </div>
  );
}
